// extracted by mini-css-extract-plugin
var _1 = "_customerCollateralDetails-module__button-container";
var _2 = "_customerCollateralDetails-module__container";
var _3 = "_customerCollateralDetails-module__details-table";
var _4 = "_customerCollateralDetails-module__product-container";
var _5 = "_customerCollateralDetails-module__show-serial-no";
export { _1 as "button-container", _2 as "container", _3 as "details-table", _4 as "product-container", _5 as "show-serial-no" }
